import { render, staticRenderFns } from "./EmailActionForm.vue?vue&type=template&id=22991452&scoped=true"
import script from "./EmailActionForm.vue?vue&type=script&lang=js"
export * from "./EmailActionForm.vue?vue&type=script&lang=js"
import style0 from "./EmailActionForm.vue?vue&type=style&index=0&id=22991452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22991452",
  null
  
)

export default component.exports